import PropTypes from 'prop-types'

import { CircleRightArrow } from '@/components/Icons'

const SpaceLandingLink = ({ children, url }: any) => (
  <li>
    <a href={url} rel="noopener noreferrer" target="_blank">
      <CircleRightArrow />
      {children}
    </a>
  </li>
)

SpaceLandingLink.displayName = 'SpaceLandingLink'

SpaceLandingLink.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.object)]),
  url: PropTypes.string.isRequired
}

SpaceLandingLink.defaultProps = {
  children: null,
  url: '#'
}

export default SpaceLandingLink
